import { render, staticRenderFns } from "./MapSaio.vue?vue&type=template&id=458c0682&"
import script from "./MapSaio.vue?vue&type=script&lang=js&"
export * from "./MapSaio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports